<ng-container [formGroup]="form">
  <div fxLayout="column">
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      fxLayoutGap="8px">
      <topo-avatar
        [name]="form?.get('display_name')?.value"
        [imageUrl]="form?.get('avatar_image')?.value"
        [size]="56"
        [fontSize]="24"></topo-avatar>
      <div fxLayout="column">
        <div
          class="text is-large is-bold"
          style="color: var(--text-color-1)">
          {{ form?.get('display_name')?.value ?? 'NOTIFICATION-PREFERENCES.DEFAULT-NAME' | translate }}
        </div>
        <div>
          <button
            (click)="editProfileClicked.emit()"
            class="button is-link">
            {{ 'NOTIFICATION-PREFERENCES.EDIT-PROFILE' | translate }}
          </button>
        </div>
      </div>
    </div>

    <!-- Form section -->
    <div class="section-title mt-4">{{ 'NOTIFICATION-PREFERENCES.CONTACT-INFORMATION' | translate }}</div>

    <div class="field mt-4">
      <label>{{ 'NOTIFICATION-PREFERENCES.LANGUAGE' | translate }}</label>
      <div class="select is-fullwidth is-primary is-medium">
        <select formControlName="culture_code">
          @for (lang of languages$ | async; track lang.cultureCode) {
            <option [ngValue]="lang.cultureCode">
              {{ 'LANGUAGES.LANGUAGE-' + lang.cultureCode | translate }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.TIME-ZONE' | translate }}</label>
      <div class="select is-fullwidth is-primary is-medium">
        <select formControlName="time_zone">
          @for (tz of timezones; track tz.nameValue) {
            <option [ngValue]="tz.nameValue">
              {{ tz.name }}
            </option>
          }
        </select>
      </div>
    </div>

    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.DO-NOT-DISTURB' | translate }}</label>
      <div
        fxLayout="row"
        fxLayoutAlign="start center"
        fxLayoutGap="8px">
        <div class="select is-fullwidth is-primary is-medium">
          <select formControlName="do_not_disturb_from_time">
            @for (hour of hours; track $index) {
              <option [ngValue]="hour[0]">
                {{ hour[1] }}
              </option>
            }
          </select>
        </div>
        <div class="field-label">{{ 'NOTIFICATION-PREFERENCES.TO' | translate }}</div>
        <div class="select is-fullwidth is-primary is-medium">
          <select formControlName="do_not_disturb_to_time">
            @for (hour of hours; track $index) {
              <option [ngValue]="hour[0]">
                {{ hour[1] }}
              </option>
            }
          </select>
        </div>
      </div>
    </div>

    <div class="section-title">{{ 'NOTIFICATION-PREFERENCES.WORK' | translate }}</div>
    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.WORK-EMAIL' | translate }}</label>
      <div style="position: relative">
        <input
          id="work_email"
          name="work_email"
          type="email"
          class="input is-primary is-fullwidth email-input-field"
          formControlName="work_email"
          [ngClass]="{ 'input-disabled': isUserAccountLinked }"
          (focus)="changeWorkEmail($event)" />
        <div
          class="edit-icon"
          [ngClass]="{ 'input-disabled': isUserAccountLinked }">
          <i class="icon icon-small_edit"></i>
        </div>
      </div>
    </div>

    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.WORK-PHONE' | translate }}</label>
      <div
        class="phone-input-container"
        (click)="changeWorkPhone($event)">
        <div style="pointer-events: none">
          <topo-phone-input formControlName="work_phone" />
          <div class="edit-icon">
            <i class="icon icon-small_edit"></i>
          </div>
        </div>
      </div>
    </div>

    @if (workPrefsView) {
      <div>
        <div
          topoDynamicForm2
          (valueChanged)="workValueChanged($event)"
          [formView]="workPrefsView"
          [schema]="_dataset?.schema"
          [layerUId]="guidEmpty"
          [document]="document"
          [controlCollection]="documentControls"
          [isEdit]="isEdit"
          [dataset]="_dataset"
          [viewContainer]="workViewContainer"></div>
      </div>
    }

    <div class="section-title">{{ 'NOTIFICATION-PREFERENCES.PERSONAL' | translate }}</div>
    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.PERSONAL-EMAIL' | translate }}</label>
      <div style="position: relative">
        <input
          type="email"
          class="input is-primary is-fullwidth email-input-field"
          formControlName="personal_email"
          (focus)="changePersonalEmail($event)" />
        <div class="edit-icon">
          <i class="icon icon-small_edit"></i>
        </div>
      </div>
    </div>

    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.PERSONAL-PHONE' | translate }}</label>
      <div
        class="phone-input-container"
        (click)="changePersonalPhone($event)">
        <div style="pointer-events: none">
          <topo-phone-input formControlName="personal_phone" />
          <div class="edit-icon">
            <i class="icon icon-small_edit"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="field">
      <label>{{ 'NOTIFICATION-PREFERENCES.WHATS-APP-ADDRESS' | translate }}</label>

      <div
        class="phone-input-container"
        (click)="changeWhatsAppAddress($event)">
        <div style="pointer-events: none">
          <topo-phone-input formControlName="whatsapp_address" />
          <div class="edit-icon">
            <i class="icon icon-small_edit"></i>
          </div>
        </div>
      </div>
    </div>
  </div>

  @if (personalPrefsView) {
    <div>
      <div
        topoDynamicForm2
        (valueChanged)="personalValueChanged($event)"
        [formView]="personalPrefsView"
        [schema]="_dataset?.schema"
        [layerUId]="guidEmpty"
        [document]="document"
        [controlCollection]="documentControls"
        [isEdit]="isEdit"
        [dataset]="_dataset"
        [viewContainer]="personalViewContainer"></div>
    </div>
  }
</ng-container>
@if (editPrefsView && !!!workPrefsView && !!!personalPrefsView) {
  <div>
    <div>
      <topo-form-group-select
        (changed)="viewContainerChanged($event)"
        [(ngModel)]="selectedViewControlContainerUId"
        [selectedViewControlContainerUId]="selectedViewControlContainerUId"
        [viewControlContainers]="viewControlContainers"></topo-form-group-select>
    </div>
    <div
      class="mt-4"
      topoDynamicForm2
      (valueChanged)="valueChanged($event)"
      [formView]="editPrefsView"
      [schema]="_dataset?.schema"
      [layerUId]="guidEmpty"
      [document]="document"
      [controlCollection]="documentControls"
      [isEdit]="isEdit"
      [dataset]="_dataset"
      [viewContainer]="selectedViewContainer"></div>
  </div>
}
